import { Component } from '../component/component';
import { DownloadItem } from './download-item';
import { MetadataItem } from './metadata-item';

export class Metadata extends Component {

	constructor(code, node) {
		super();
		this.node = node;
		this.getMetadata(code);
	}

	update(code) {
		this.getMetadata(code);
	}

	getMetadata(code) {
		let url;
		code = code.replace('/', '__');
		url = `/api/configurator/products/metadati/${productSheet.idDoc}/${code}?state=true`;
		fetch(url)
			.then(r => r.json())
			.then(data => {
				this.data = data;
				const dataItems = data ? data.metadati.map((item) => {
					return new MetadataItem(item);
				}) : [];
				this.updateMetadata(dataItems);
				const downloadGroups = data ? data.downloads.map(downloads => downloads.map((item) => {
					return new DownloadItem(item);
				})) : [];
				this.updateDownloads(downloadGroups);
				this.updateVersionCode(data.codiceVersione);
				this.emit('loaded', data);
			})
			.catch(e => console.log('Metadata.getMetadata.error', e.message));
	}

	updateMetadata(dataItems) {
		if (this.dataNode) {
			this.dataNode.remove();
		}
		const dataNode = this.dataNode = document.createElement('div');
		dataNode.classList.add('dati-prodotto');
		dataItems.forEach(item => {
			dataNode.appendChild(item.node);
		});
		this.node.insertBefore(dataNode, this.node.firstChild);
	}

	updateDownloads(downloadGroups) {
		const node = document.querySelector('.documentazione');
		if (node) {
			let downloadNode;
			while (downloadNode = node.querySelector('.download')) {
				downloadNode.remove();
			}
			downloadGroups.forEach(downloads => {
				downloadNode = document.createElement('ul');
				downloadNode.classList.add('download');
				downloads.forEach(item => {
					downloadNode.appendChild(item.node);
				});
				node.appendChild(downloadNode);
			});
		}
	}

	updateVersionCode(codiceVersione) {
		const node = document.querySelector('.documentazione .tit .code');
		if (node) {
			node.innerHTML = codiceVersione;
		}
	}
}
